import {
  type ListContentItemsParams,
  type ListContentItemsStatusItem,
  makeQueryString,
  parseLimit,
} from '@metapic-apps/shared'

import type {
  ContentItemsFilterServerType,
  ContentItemsFilterType,
} from '@/lib/types/content-items.types'

const handleFilter = (filter: ContentItemsFilterType): ContentItemsFilterServerType => {
  const { contentTypes: _contentTypes, ...rest } = filter
  const processedFilter: ContentItemsFilterServerType = { ...rest }

  delete processedFilter.campaign
  delete processedFilter.creator
  delete processedFilter.createdByMe

  if (filter.creator) {
    processedFilter.creatorIds = [filter.creator.id]
  }

  if (filter.campaign) {
    processedFilter.campaignIds = [filter.campaign.id]
  }

  if (filter.contentTypes?.length) {
    processedFilter.type = filter.contentTypes
  }

  return processedFilter
}

export const makeQueryStringForContentItems = (filter: ContentItemsFilterType): string | null => {
  return makeQueryString(handleFilter(filter), true)
}

export const handleContentItemFilter = (filter: ContentItemsFilterType): ListContentItemsParams => {
  const params: ListContentItemsParams = {}

  if (filter.page !== undefined) {
    params.page = filter.page
  }

  const limit = parseLimit(filter.limit ?? filter.size)
  if (limit !== undefined) {
    params.limit = limit
  }

  if (filter.advertiser) {
    params.advertiser_ids = [filter.advertiser.id]
  }

  if (filter.advertiserGroupId !== undefined) {
    params.advertiser_group_ids = [filter.advertiserGroupId]
  } else if (filter.advertiserGroup) {
    params.advertiser_group_ids = [filter.advertiserGroup.id]
  }

  if (filter.creator) {
    params.creator_ids = [filter.creator.id]
  }

  if (filter.campaign) {
    params.campaign_ids = [filter.campaign.id]
  }

  const dateFrom = filter.dateFrom ?? filter.startDate
  if (dateFrom) {
    params.date_from = dateFrom
  }

  const dateTo = filter.dateTo ?? filter.endDate
  if (dateTo) {
    params.date_to = dateTo
  }

  if (filter.statuses?.length) {
    params.status = filter.statuses as ListContentItemsStatusItem[]
  } else if (filter.status) {
    params.status = [filter.status] as ListContentItemsStatusItem[]
  }

  if (filter.contentTypes?.length) {
    params.type = filter.contentTypes
  }

  if (filter.sortBy) {
    params.sort_by = filter.sortBy
  }

  return params
}
